import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseHeader = ({ className }: IProps) => (
    <div className={className}>
        <h2>Wat kost mijn bril op sterkte?</h2>
        <p>
            Bij Pearle hebben we zes heldere glaspakketten voor je samengesteld:
            basis, brons, zilver, goud, diamant en platinum. Zo zie je meteen
            welke glazen je wilt en wat ze kosten. Geen verrassingen dus.
        </p>
    </div>
);

export const Header = styled(BaseHeader)`
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
    padding: 0 15px;
`;
